<template>
    <div class="space-y-10">
        <account></account>
        <password-change></password-change>
    </div>
</template>

<script>
import Account from "@/scripts/components/app/account/Account.vue";
import PasswordChange from "@/scripts/components/app/account/PasswordChange.vue";

export default {
    components: {Account, PasswordChange},
}
</script>
